import classNames from 'classnames'

import { NoticeIcon } from '../../../icons/NoticeIcon'
import { Tooltip } from '../../../ui/Popups/Tooltip/Tooltip'

import styles from './TableHeaderTooltip.module.scss'

interface TableHeaderTooltipProps<T extends Record<string, string>> {
  headerIds: Partial<T>
  targetHeaderId: keyof T
}

export const TableHeaderTooltip = <T extends Record<string, string>>({
  headerIds,
  targetHeaderId,
}: TableHeaderTooltipProps<T>): JSX.Element => {
  const content = headerIds[targetHeaderId]

  if (content) {
    return (
      <div
        onClick={(e) => e.stopPropagation()}
        className={classNames(styles.infoIconWrapper, styles.infoIcon)}
      >
        <Tooltip content={content} isNew wrapperClassName={styles.infoIcon}>
          <NoticeIcon color='foregroundNeutral' size={13.3} className={styles.infoIcon} />
        </Tooltip>
      </div>
    )
  }

  return <></>
}
